"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignsListResponseToJSON = exports.CampaignsListResponseFromJSONTyped = exports.CampaignsListResponseFromJSON = exports.instanceOfCampaignsListResponse = void 0;
var runtime_1 = require("../runtime");
var CampaignResponse_1 = require("./CampaignResponse");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the CampaignsListResponse interface.
 */
function instanceOfCampaignsListResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCampaignsListResponse = instanceOfCampaignsListResponse;
function CampaignsListResponseFromJSON(json) {
    return CampaignsListResponseFromJSONTyped(json, false);
}
exports.CampaignsListResponseFromJSON = CampaignsListResponseFromJSON;
function CampaignsListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'campaigns': !(0, runtime_1.exists)(json, 'campaigns') ? undefined : (json['campaigns'].map(CampaignResponse_1.CampaignResponseFromJSON)),
    };
}
exports.CampaignsListResponseFromJSONTyped = CampaignsListResponseFromJSONTyped;
function CampaignsListResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'campaigns': value.campaigns === undefined ? undefined : (value.campaigns.map(CampaignResponse_1.CampaignResponseToJSON)),
    };
}
exports.CampaignsListResponseToJSON = CampaignsListResponseToJSON;
